<template>
  <div class="wrapper">
    <div class="toggle_radio" :style="{width: radioWidth}">
      <div v-for="(option, index) in inputOptions">
        <input type="radio" class="toggle_option" :id="field+'toggle-'+index" name="toggle_option" :value="option" v-model="model[field]" v-if="model[field] === option" checked="true">
        <input type="radio" class="toggle_option" :id="field+'toggle-'+index" name="toggle_option" :value="option" v-model="model[field]" v-else>
        <label :for="field+'toggle-'+index"><p>{{ option }}</p></label>
      </div>
      <div class="toggle_option_slider" :style="{left: sliderWidth}">
      </div>
    </div>
  </div>
</template>

<script>
import inputHelpers from './input-helpers'

export default {
  mixins: [inputHelpers],
  computed: {
    sliderWidth () {
      return (this.inputOptions.indexOf(this.model[this.field]) * 100) + 'px'
    },
    radioWidth () {
      return (this.inputOptions.length * 100) + 'px'
    }
  }
}
</script>

<style lang='scss' scoped>
  @import '../../../../sass/variables';
  .wrapper {
    margin: 0 0;
  }
  .toggle_radio{
    position: relative;
    background: $fractel-teal;
    margin: 4px auto;
    overflow: hidden;
    padding: 0 !important;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    position: relative;
    height: 26px;
    width: 0px;
  }
  .toggle_radio > * {
    float: left;
  }
  .toggle_radio input[type=radio]{
    display: none;
    /*position: fixed;*/
  }
  .toggle_radio label{
    font: 90%/1.618 "Source Sans Pro";
    color: rgba(255,255,255,.9);
    z-index: 0;
    display: block;
    width: 100px;
    height: 26px;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    cursor: pointer;
    z-index: 1;
    /*background: rgba(0,0,0,.1);*/
    text-align: center;
    /*margin: 0 2px;*/
    /*background: blue;*/ /*make it blue*/
  }
  .toggle_option_slider{
    /*display: none;*/
    /*background: red;*/
    background: rgba(255,255,255,.3);
    width: 100px;
    height: 26px;
    position: absolute;
    -webkit-border-radius: 50px;
    -moz-border-radius: 50px;
    border-radius: 50px;
    -webkit-transition: all .4s ease;
    -moz-transition: all .4s ease;
    -o-transition: all .4s ease;
    -ms-transition: all .4s ease;
    transition: all .4s ease;
  }
</style>



// WEBPACK FOOTER //
// src/fractel/components/vue-mc/form/mc-radio-slider.vue